import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { FuneralType as FT } from 'src/resources'
import { RedBtn } from 'src/components/atoms/input/buttons'
import Link from 'src/components/atoms/input/buttons/Link'
import { StoreProps } from 'src/stores'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { media } from 'src/utils.js'
import CustomModal from '../../containers/CustomModal'
import ReactHtmlParser from 'react-html-parser'

interface ModalProps {
  open: boolean
  onClose: () => void
  confStore: any
}
const ChangeFuneralTypeModal = (props: ModalProps) => {
  const [selected, setSelected] = React.useState<FT>(null)
  const [loading, setLoading] = React.useState<boolean>(false)

  const { open, onClose, confStore } = props

  const funeralTypeName = (f = null) => {
    const toCheck = f || confStore.getFuneralType()
    switch (toCheck) {
      case 'BURIAL':
        return 'Erdbestattung'
      case 'CREMATION':
        return 'Feuerbestattung'
      case 'TREE_FUNERAL':
        return 'Baumbestattung'
      case 'SEA_FUNERAL':
        return 'Donaubestattung'
      case 'HOME_URN':
        return 'Urne zu Hause'
      case 'GEMSTONE_FUNERAL':
        return 'Edelsteinbestattung'
      default:
        return 'Lädt ...'
    }
  }

  const selectFuneralType = (funeralType) => {
    setSelected(funeralType)
  }

  const changeOfferFuneralType = () => {
    setLoading(true)
    confStore
      .changeOfferFuneralType(confStore.getOffer.uuid, selected)
      .then(() => {
        onClose()
        window.location.reload()
      })
  }

  return (
    <CustomModal title='Bestattungsart ändern' open={open} onClose={onClose}>
      <ModalText>
        Bei der Organisation einer Bestattung bieten sich unterschiedliche
        Bestattungsarten zur Auswahl an. Gerne können Sie hier eine andere
        Bestattungsart wählen, um Leistungen und Preise zu vergleichen. Bitte
        beachten Sie jedoch, dass bei einem Wechsel der Bestattungsart Ihre
        bisherige <u>Produktauswahl verloren</u> geht.
      </ModalText>
      <FTCardContainer>
        {loading ? (
          <h4>Sie werden gleich weitergeleitet ...</h4>
        ) : (
          confStore.getCatalogue.getProductsByType('FUNERAL').map((f) => {
            // let price = f.prices[0].amount / 100
            // // This is necessary as technically a coffin / urn is always part
            // // of a burial. Therefore the cheapest option is added
            // if (f.availableFor[0] === 'BURIAL') price += 650
            // if (f.availableFor[0] === 'CREMATION') price += 80
            // if (f.availableFor[0] === 'HOME_URN') price += 80
            // if (f.availableFor[0] === 'TREE_FUNERAL') price += 92
            // if (f.availableFor[0] === 'SEA_FUNERAL') price += 104
            return (
              <FTCard
                key={f.availableFor[0]}
                onClick={() => selectFuneralType(f.availableFor[0])}
                selected={selected === f.availableFor[0]}>
                <img src={`${f.photos[0]}`} alt='funeral_icon' />
                <p>
                  {funeralTypeName(f.availableFor[0])}
                  {/* <br />
                  <small>ab {price} €</small> */}
                </p>
              </FTCard>
            )
          })
        )}
      </FTCardContainer>
      <RedBtn disabled={!selected} onClick={() => changeOfferFuneralType()}>
        Bestattungsart ändern
      </RedBtn>
    </CustomModal>
  )
}

interface Props extends StoreProps {
  index?: number
}

interface State {
  modalOpen: boolean
}

@inject('confStore')
@observer
export default class FuneralType extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      modalOpen: false
    }
  }

  toggleModal = () => {
    const { modalOpen } = this.state
    this.setState({ modalOpen: !modalOpen })
  }

  render() {
    const { confStore, index } = this.props
    const { modalOpen } = this.state

    const funerals = confStore.getCatalogue.getProductsByType('FUNERAL')
    const funeral =
      funerals !== undefined
        ? funerals.filter(
            (f) => f.availableFor[0] === confStore.getOffer.funeralType
          )[0]
        : null

    return (
      <ConfiguratorBox
        collapsable
        defaultCollapsed
        title={`${index}. Basisleistungen`}
        idLabel={`expand-arrow-funeral-type`}>
        {!!funeral && (
          <>
            <PriceHeadline
              icon={funeral.photos[0]}
              service={confStore.getProductsOfTypeInOffer('FUNERAL')[0].name}
              price={
                confStore.getProductsOfTypeInOffer('FUNERAL')[0].prices[0]
                  .amount / 100
              }
            />
            <div className='product-long-desc'>
              {ReactHtmlParser(funeral.longDescription)}
            </div>
            {!confStore.getOffer.orderConfirmed && (
              <>
                <Link light onClick={this.toggleModal}>
                  Bestattungsart ändern
                </Link>

                <ChangeFuneralTypeModal
                  onClose={this.toggleModal}
                  open={modalOpen}
                  confStore={confStore}
                />
              </>
            )}
          </>
        )}
      </ConfiguratorBox>
    )
  }
}

const ModalText = styled.p`
  display: block;
  max-width: 800px;
  margin: 0 auto 15px auto;
  text-align: center;
`

const FTCardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: auto;
`

const FTCard = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 50%;
  min-width: 270px;
  padding: 7.5px;
  margin: 7.5px;
  border-left: 4px solid #677d7f;
  background-image: linear-gradient(to left, #677d7f 50%, #d5e4e6 50%);
  background-size: 200% 100%;
  transition: background-position 0.3s;
  will-change: background-position;
  cursor: pointer;

  &:hover {
    background-position: -100% 0;
    p {
      color: #f0f0f0;
    }
    img {
      filter: grayscale(1) brightness(2);
    }
  }

  & > * {
    margin: 10px;
  }

  img {
    transition: filter 0.3s;
    will-change: filter;
  }

  p {
    line-height: 1;
    text-align: left;
    font-size: 18px;
    color: #4a4a4a;
    transition: color 0.4s;
    will-change: color;

    small {
      font-size: 15px;
    }

    ${media.tablet`
      font-size: 17px;
      small {
        font-size: 13px;
      }
    `}
  }
  ${(props) =>
    props.selected &&
    `
      background-position: -100% 0;
      p {
        color: #f0f0f0;
      }
      img {
        filter: grayscale(1) brightness(2);
      }
   `}
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/FuneralType.tsx